<template>
	<Modal
		:is-open="isOpen"
		@update:is-open="(newValue: boolean) => isOpen = newValue"
	>
		<div class="py-10">
			<div class="text-center rem:max-w-[614px] mx-auto">
				<div
					class="inline-flex justify-center items-center mb-10 rounded-full rem:w-[100px] rem:h-[100px]"
					:class="error ? 'bg-functional-error-secondary' : 'bg-functional-success-secondary'"
				>
					<NuxtIcon v-if="error" name="x" filled class="text-6xl text-functional-error-primary" />
					<NuxtIcon v-else name="check" filled class="text-6xl text-functional-success-primary" />
				</div>
				<h2 class="typo-h4 text-heading-secondary mb-6">
					<slot name="heading" />
				</h2>
				<div class="mb-8">
					<slot name="text" />
				</div>
				<button
					type="button"
					class="btn btn-primary btn-lg px-16 rem:min-w-[230px] justify-center"
					@click="isOpen = false"
				>
					Ok, rozumím
				</button>
			</div>
		</div>
	</Modal>
</template>

<script setup lang="ts">
	interface Props {
		isOpen?: boolean;
		error?: boolean;
	}

	const props = defineProps<Props>();
	const emit = defineEmits(['update:isOpen']);
	const isOpen = useVModel(props, 'isOpen', emit);
</script>
